import { Directive, Input } from '@angular/core';

@Directive()
export abstract class HorizontalLineBaseComponent {
  @Input() className?: string;
}
